export default "__VITE_ASSET__B3L2TUcZ__"